import { ROLES } from "@typings/entities/users/enums";
import { env } from "./env";
import { paths } from "./paths";
import { permissions } from "./permissions";

export interface Config {
  site: {
    name: string;
    apiUrl: string;
  };
  mapbox: {
    accessToken: string;
  };
  uploadArchive: {
    multiple: boolean;
    accept: string[];
    maxFiles: number;
  };
  imageCompression: {
    useWebWorker: boolean;
    maxSizeMB: number;
    maxWidthOrHeight: number;
    initialQuality: number;
    imageTypes: string[];
  };
  attachmentsGallery: {
    defaultPageSize: number;
  };
  map: {
    latitude: number;
    longitude: number;
    zoom: number;
    style: string;
    styleSatellite: string;
  };
  swr: {
    refreshInterval: number;
    revalidateOnFocus: boolean;
    keepPreviousData: boolean;
    revalidateOnReconnect: boolean;
    dedupingInterval: number;
    shouldRetryOnError: boolean;
    errorRetryCount: number;
    errorRetryInterval: number;
  };
  pages: {
    label: string;
    path?: string;
    outsideMenu?: boolean;
    roles?: (typeof ROLES)[keyof typeof ROLES][];
    subpages?: {
      label: string;
      path?: string;
      roles?: (typeof ROLES)[keyof typeof ROLES][];
    }[];
  }[];
  table: {
    pageSizeOptions: number[];
    defaultPageSize: number;
  };
}

export const config: Config = {
  site: {
    name: "Guará",
    apiUrl: env.VITE_API_URL,
  },
  mapbox: {
    accessToken: env.VITE_APP_MAPBOX_ACCESS_TOKEN,
  },
  uploadArchive: {
    multiple: true,
    accept: [".jpg", ".jpeg", ".png", ".pdf"],
    maxFiles: 5,
  },
  imageCompression: {
    useWebWorker: true,
    maxSizeMB: 1,
    maxWidthOrHeight: 1920,
    initialQuality: 0.6,
    imageTypes: ["image/jpeg", "image/jpg", "image/png"],
  },
  map: {
    latitude: -17.850031,
    longitude: -47.666106,
    zoom: 8.8,
    style: "mapbox://styles/mapbox/standard",
    styleSatellite: "mapbox://styles/mapbox/standard-satellite",
  },
  swr: {
    refreshInterval: 0,
    revalidateOnFocus: false,
    keepPreviousData: true,
    revalidateOnReconnect: true,
    dedupingInterval: 2000,
    shouldRetryOnError: true,
    errorRetryCount: 3,
    errorRetryInterval: 3000,
  },
  attachmentsGallery: {
    defaultPageSize: 10,
  },
  pages: [
    { label: "Início", path: paths.home },
    { label: "Gestão de Solturas", path: paths.managingReleases },
    {
      label: "Fauna",
      subpages: [
        { label: "Indivíduos", path: paths.individuals },
        { label: "Grupos Taxonômicos", path: paths.taxonomicGroups },
        { label: "Registros", path: paths.registers },
        { label: "Amostras", path: paths.samples },
      ],
    },
    { label: "Comunidade do Entorno", path: paths.community },
    { label: "Sensores e Dispositivos", path: paths.devices },
    { label: "Usuários", path: paths.users, roles: permissions.users?.read },
    { label: "Notificações", path: paths.notifications },
    { label: "Relatórios", path: paths.reports },
    { label: "Perfil", path: paths.profile, outsideMenu: true },
  ],
  table: {
    pageSizeOptions: [5, 10, 25, 50, 100, 500],
    defaultPageSize: 10,
  },
};
